import React, { useEffect, useState, Fragment } from 'react';
import { Pagination, PageHeader, paginate } from '../../../Common';
import { TableContent} from '../../Common/Table/tableContent';
import { Fields, validateProperty, validate, Card } from "../../Common";
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import services from '../services';
import { search, SearchFeild } from '../../Common';
import MenuItem from '@material-ui/core/MenuItem';
import $ from 'jquery';
import { gangSchemaObject } from '../gangSchema';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';

import Joi from '@hapi/joi'
import { TextField } from '@material-ui/core';
import FileBase64 from 'react-file-base64';
import FormHelperText from '@material-ui/core/FormHelperText';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';

const screenCode = 'GANG'

export function Listing(props) {
    const [gang, setGang] = useState([]);
    const [gangSearch, setGangSearch] = useState({
        groupID: 0,
        operationEntityID: 0,
        collectionPointID:0,
        fieldID:0

    });
    const [groups, setGroups] = useState()
    const [estates, setEstates] = useState()
    const [devisions, setDevisions] = useState()
    const [fields, setFeilds] = useState()
    const [isTableHide, setIsTableHide] = useState(true);
    const contentRowNames = ["gangName", "createdDate", "isActive"]
    const [errors, setErrors] = useState({});
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const schema = Joi.object(gangSchemaObject).options({ allowUnknown: true });
   
    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(
            getEstates()
        )
    }, [gangSearch.groupID])

    useEffect(() => {
        trackPromise(
            getDevisions()
        )
    }, [gangSearch.operationEntityID])


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWGANG');
        if(isAuthorized === undefined){
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDEDITGANG');
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !==undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setGangSearch({
            ...gangSearch,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });
        getAllGroups();
    }
    async function getDevisions() {
        const result = await services.getDivisions(gangSearch.operationEntityID)
        setDevisions(result)
    }
    async function getEstates(){
        var data = await services.getEstatesByGroupID(gangSearch.groupID);
        setEstates(data)
    }

    async function getAllGroups() {
        const result = await services.getGroups()
        setGroups(result)
    }
    
    function destroyDataTable() {
        $('#example').DataTable().destroy();
    }

    function createDataTable() {
        $('#example').DataTable();
    }

    function handleClick(gang) {
        props.history.push({
            pathname: 'gang/addEdit',
            data: gang,
            edit: true
        })
    }

    function generateDropDownMenu(data) {

        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }
    async function getGang(operationEntityID, collectionPointID) {
        const data = await services.getAllGangByFilter(operationEntityID, collectionPointID);
        return data;
    }

    async function handleSearch() {
        if(gangSearch.operationEntityID != 0 && gangSearch.collectionPointID != 0){
            destroyDataTable();
            var data = await getGang(gangSearch.operationEntityID, gangSearch.collectionPointID);
            if(data !== []) {
                setIsTableHide(false);
            }
            setGang(data);
            createDataTable();
        }
    }

    function handleGroupChange(target){
        validateInputs(target);

        setGangSearch({
            ...gangSearch,
            groupID: target.value,
            operationEntityID: '0',
            collectionPointID:'0'
        })
    }

    function handleEstateChange(target){
        validateInputs(target);
        setGangSearch({
            ...gangSearch,
            operationEntityID: target.value,
            collectionPointID:'0'
        })
    }
    function handleDivisionChange(target){
        validateInputs(target);
        setGangSearch({
            ...gangSearch,
            collectionPointID:target.value
        })
    }
    
    function validateInputs(target){
        const error = {...errors};
        const errorMessage = validateProperty(target, gangSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setErrors(error)
        
    }

    function clearState() {
        var token = tokenService.getUserDetailsFromToken();
        setGangSearch({
            ...gangSearch,
            groupID: !permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            operationEntityID: !permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntityID,
            collectionPointID: '0'
        });
        destroyDataTable();
        setGang([]);
        setIsTableHide(true);
    }

    function onCancelClick() {
        setErrors({});
        clearState();
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title="Gang"
                                    isButtonEnable={permissionList.isAddEditEnabled}
                                    buttonText="Add Gang Details"
                                    path="gang/addEdit" />
                            </div>
                            <hr />

                            <form onSubmit={(e) => trackPromise( handleSearch(e))}>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={gangSearch.groupID}
                                            onChange={(e) => handleGroupChange(e.target)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Estate *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="operationEntityID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            name="operationEntityID"
                                            value={gangSearch.operationEntityID}
                                            onChange={(e) => handleEstateChange(e.target)}>
                                            
                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="collectionPointID">Division *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="collectionPointID"
                                            name="collectionPointID"
                                            value={gangSearch.collectionPointID}
                                            onChange={(e) => handleDivisionChange(e.target)}>
                                            <MenuItem value="0">--Select Division--</MenuItem>
                                            {generateDropDownMenu(devisions)}
                                        </Select>
                                        {errors["collectionPointID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                    </div>

                 
                                </div>
                                <div className="form-group row">
                                {/* <div className="col-md-4 pb-1">
                                        <InputLabel shrink id="fieldID">Field</InputLabel>
                                        <Select
                                            fullWidth
                                            id="fieldID"
                                            name="fieldID"
                                            value={gangSearch.fieldID}
                                            onChange={(e) => handleFieldChange(e.target)}>
                                            
                                            <MenuItem value="0">--Select Field--</MenuItem>
                                            {generateDropDownMenu(fields)}
                                        </Select>
                                        {errors["fieldID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["fieldID"]}</FormHelperText>}
                                    </div> */}

                                </div>
                                <div className="card-footer">
                                    <input

                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={(e) => handleSearch(e)}
                                    />
                                    <input
                                        type="button"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />

                                </div>

                            </form>

                            <div className="table-responsive row-top-gap" >
                            <table id="example" className="display dataTable no-footer" hidden={isTableHide}>
                                <thead>
                                    <tr>                                    
                                        <th>Gang Name</th>
                                        <th>Create Date</th>
                                        <th>Status</th>
                                        { permissionList.isAddEditEnabled ? <th>Actions</th> : null }
                                    </tr>
                                </thead>
                                <tbody>
                                     <TableContent
                                            data={gang}
                                            contentRowNames={contentRowNames}
                                            handleClick={handleClick}
                                            hasEdit={permissionList.isAddEditEnabled}
                                    />
                                </tbody>
                            </table>
                        </div>

                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
        

}